import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { Button, Checkbox, Form, Select, Grid, Label, Header, Icon, Modal } from 'semantic-ui-react'
import { sendAction, addMailAction, getDestination, saveTypeCompany, addCuitAction } from './accions'
import sha1 from 'crypto-js/sha256'
import Base64 from 'crypto-js/enc-base64'

// import './step1.css'
import '../../genericStyles.css'

export class Step1 extends Component {
    state = {
        amount: 50000,
        deadline: 6,
        colorButton6: '#f9690e',
        colorButton12: '#838787',
        formattedMin: '',
        email: '',
        destination: '',
        checked: false,
        redirectToReferrer: false,
        errors: {
            email: false,
            destination: false
        },
        showMessage: false,
        message: '',
        _loading: false,
        _loadSelect: true,
        destinations: [],
        referral: 'Credility',
        cuit: '',
        valueCheckbox: '',
        inputPass: null,
        inputRep: null,
        vendedor: '',
        step: '',
        open: false,
        banco: '',
        _redirectToLogin: false
    }

    static propTypes = {
        handleSendMail: PropTypes.func,
        handleEmail: PropTypes.func,
        handleDestination: PropTypes.func,
        message: PropTypes.any,
        destinations: PropTypes.array,
        isLoggerdIn: PropTypes.bool
    }

    static defaultProps = {
        message: '',
        isLoggerdIn: false
    }

    componentWillMount() {
        this.props.handleDestination();
        if (this.props.match.params.monto === 'step99' || this.props.match.params.plazo === 'step99') {
            this.setState({
                redirectToReferrer: true,
                step: 'step99'
            })
        } else {
            if (this.props.match.params.monto && this.props.match.params.plazo) {
                var montoArray = this.props.match.params.monto.split('.')
                var monto = '';
                for (let index = 0; index < montoArray.length; index++) {
                    monto += montoArray[index];
                }
            }
            var amount = parseInt(monto, 10) || this.state.amount
            var deadline = parseInt(this.props.match.params.plazo, 10) || this.state.deadline
            this.setState({
                amount: amount,
                deadline: deadline
            })
        }
        let banco = window.location.pathname.split('/')[1];
        if (banco === '/') {
            this.setState({ banco: 'credility', referral: 'Credility' });
        } else {
            this.setState({ banco: banco, referral: banco.charAt(0).toUpperCase() + banco.slice(1) });
        }
        this.readTextFile(`./TerminosYCondiciones/${banco}.html`);
    }


    readTextFile = file => {
        var rawFile = new XMLHttpRequest();
        rawFile.open("GET", file, false);
        rawFile.onreadystatechange = () => {
            if (rawFile.readyState === 4) {
                if (rawFile.status === 200 || rawFile.status === 0) {
                    var allText = rawFile.responseText;
                    this.setState({
                        fundData: allText
                    });
                }
            }
        };
        rawFile.send(null);

    };

    componentWillReceiveProps(nextProps) {
        const {
            message,
            destinations,
            redirect
        } = nextProps;
        if (message !== 'done') {
            if (!redirect || redirect === '') {
                this.setState({
                    redirectToReferrer: false,
                    showMessage: true,
                    message: message,
                    _loading: false,
                    _loadSelect: false,
                    destinations
                })
            } else {
                this.setState({
                    redirectToReferrer: true,
                    step: redirect
                })
            }

        } else {
            this.setState({
                redirectToReferrer: true,
                step: redirect
            })
        }

    }

    handleSubmit = async event => {
        const {
            destination,
            email,
            checked,
            amount,
            deadline,
            referral,
            inputPass,
            vendedor,
            cuit,
            valueCheckbox
        } = this.state
        const hashDigest = sha1(inputPass);

        const password = Base64.stringify(hashDigest);
        if (cuit !== '' && cuit.length === 11 && valueCheckbox !== '') {
            if (destination !== 'Préstamo Personal' && destination !== 'Renovación de controladores fiscales' && destination !== '' && email !== '' && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) && checked && this.handlePass()) {
                this.props.handleEmail(email);
                this.props.handleCompany(valueCheckbox);
                const asd = await this.props.handleSendMail({
                    destination,
                    email,
                    amount,
                    deadline,
                    referral,
                    password,
                    valueCheckbox,
                    cuit
                })
                if (!(asd.payload)) {
                    this.setState({
                        _loading: true,
                        redirectToReferrer: true,
                        showMessage: false,
                        message: ''
                    })
                }
            } else {
                if (destination === 'Renovación de controladores fiscales' && destination !== '' && email !== '' && checked && vendedor !== '') {
                    this.props.handleEmail(email);
                    this.props.handleCompany(valueCheckbox);
                    this.props.handleSendMail({
                        destination,
                        email,
                        amount,
                        deadline,
                        referral,
                        password,
                        valueCheckbox,
                        vendedor,
                        cuit
                    });

                    this.setState({
                        _loading: true,
                        showMessage: false,
                        message: ''
                    })

                } else {
                    if (destination === 'Préstamo Personal' && destination !== '' && email !== '' && checked) {
                        this.setState({
                            showMessage: false,
                            message: ''
                        })
                        window.location.href = "https://www.credility.com/landing-personal?nuevo=true"
                    } else {

                        this.setState({
                            message: 'Verifica tus datos para poder continuar',
                            showMessage: true
                        })
                    }
                }
            }
        } else {
            alert('Completá todos campos requeridos (*) para continuar')
        }

    }

    onKeyPress(event) {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        if (!/[0-9]/.test(keyValue))
            event.preventDefault();
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    toggle = () => this.setState({ checked: !this.state.checked })

    currency = (value) => {
        var result = value.toFixed(0).replace(/./g, function (c, i, a) {
            return i && c !== "," && ((a.length - i) % 3 === 0) ? '.' + c : c
        });
        return result
    }
    handlePass = () => {
        const {
            inputPass,
            inputRep,
        } = this.state

        let errors = true

        // if (inputRep !== null && inputPass !== null && inputRep === inputPass && inputPass.length > 5 && /[a-z]/.test(inputPass) && /[0-9]/.test(inputPass)) {
        //     errors = false
        // }
        if (inputRep !== null && inputPass !== null && inputRep === inputPass) {
            errors = false
        }

        if (!errors) {
            return true
        } else {
            // this.setState({
            //     message: 'Las contraseñas debes ser iguales',
            //     showMessage: true
            // })
            return false
        }

    }

    show = dimmer => () => this.setState({ dimmer, open: true })
    close = (e) => {
        // var rta = (e.target.textContent === 'Aceptar');
        this.setState({ open: false });
    }
    toggle = () => this.setState(prevState => ({ checked: !prevState.checked }))

    handleLogin = () => {
        this.setState({
            _redirectToLogin: true
        })
    }


    render() {
        const {
            redirectToReferrer,
            errors,
            _loading,
            showMessage,
            message,
            destination,
            destinations,
            _loadSelect,
            valueCheckbox,
            step,
            open, dimmer,
            banco,
            _redirectToLogin,
            fundData
        } = this.state

        const { redirect } = this.props;
        const textHead = '¡Vamos a empezar!'
        const text = 'Necesitamos que completes algunos datos para conocer más de tu negocio y poder hacerte una oferta de crédito. ¡Pero no te asustes! Son menos de 10 minutos de tu tiempo.'

        if (redirect === '/step99') {
            return <Redirect to={{ pathname: '/' + banco + '/greeting' }} />;
        } else {
            if (redirect && redirect !== '' && redirect !== '/step99') {
                return <Redirect to={{ pathname: '/' + banco + redirect }} />;
            } else if (redirectToReferrer) {
                return <Redirect to={{ pathname: '/' + banco + '/step1' }} />;
            }
        }
        if (_redirectToLogin) {
            return <Redirect to={{ pathname: '/' + banco + '/login' }} />
        }

        return (
            <Grid centered>
                <Grid.Column mobile={14} tablet={10} computer={10}>
                    <Form onSubmit={this.handleSubmit} loading={_loading}>
                        <h2 className={`h2-${banco}`}>
                            {textHead}
                        </h2>
                        <p>
                            {text}
                        </p>
                        <br />
                        <div style={{ display: 'flex', width: '100%', marginBottom: '14px' }}>
                            <div style={{ width: '50%' }}>
                                <Form.Input
                                    label='CUIT del negocio'
                                    placeholder='27925702337'
                                    name='cuit'
                                    onChange={this.handleChange}
                                    onKeyPress={this.onKeyPress.bind(this)}
                                    type='number'
                                    required
                                /></div>
                            <div style={{ marginLeft: '14px' }} required>
                                <label style={{ display: 'inline-flex' }}><strong>Tipo de empresa</strong><p style={{ color: 'red', margin: '-.2em 0 0 .2em' }}>*</p></label>
                                <Form.Group style={{ marginTop: '5px' }} required>
                                    <Form.Field>
                                        <Checkbox
                                            label='Sociedad'
                                            name='valueCheckbox'
                                            value='S.A. o S.R.L.'
                                            checked={valueCheckbox === 'S.A. o S.R.L.'}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Checkbox
                                            label='Monotributo / Autónomo'
                                            name='valueCheckbox'
                                            value='Unipersonal o Monotributo'
                                            checked={valueCheckbox === 'Unipersonal o Monotributo'}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Field>
                                </Form.Group>
                            </div>
                        </div>
                        <Form.Field
                            control={Select}
                            name='destination'
                            label='Destino del Crédito'
                            options={destinations}
                            placeholder='Destino del Crédito'
                            onChange={this.handleChange}
                            required
                            error={errors.destination}
                            loading={_loadSelect}
                        />
                        {
                            destination === 'Renovación de controladores fiscales' ? (
                                <Form.TextArea
                                    label='Vendedor del Controlador Fiscal'
                                    placeholder='Por favor indicanos a quién le vas a comprar el controlador fiscal.'
                                    name='vendedor'
                                    onChange={this.handleChange}
                                    required
                                    error={errors.vendedor}
                                />
                            ) : null
                        }
                        <br />
                        <p>Con tu correo electrónico y contraseña vas a a poder cargar los datos cuando quieras y en forma segura. </p>
                        <Form.Input
                            label='Email'
                            placeholder='Email'
                            name='email'
                            onChange={this.handleChange}
                            type='input'
                            required
                            error={errors.email}
                        />
                        <Form.Group widths='equal'>
                            <Form.Input
                                label='Contraseña'
                                placeholder='Contraseña'
                                name='inputPass'
                                onChange={this.handleChange}
                                type='password'
                                required
                            />
                            <Form.Input
                                label='Repetir Contraseña'
                                placeholder='Repetir Contraseña'
                                name='inputRep'
                                onChange={this.handleChange}
                                type='password'
                                required
                            />
                        </Form.Group>
                        <Form.Field>
                            <Checkbox onChange={this.toggle} checked={this.state.checked} label={<label>Acepto <a onClick={this.show(true)} style={{ cursor: 'pointer' }}>Términos y Condiciones</a></label>} />

                            <Modal dimmer={dimmer} open={open} onClose={this.close}>
                                <Modal.Header>Términos y Condiciones</Modal.Header>
                                <Modal.Content>
                                    <Modal.Description>
                                        <div dangerouslySetInnerHTML={{ __html: fundData }} />
                                    </Modal.Description>
                                </Modal.Content>
                                {/* <Modal.Actions>
                                    <Button negative onClick={this.close}>
                                        <Icon name='remove' /> Rechazar
                                    </Button>

                                    <Button
                                        positive
                                        icon='checkmark'
                                        labelPosition='right'
                                        onClick={this.close}>
                                        <Icon name='checkmark' />Aceptar</Button>
                                </Modal.Actions> */}
                            </Modal>
                        </Form.Field>
                        <Button className={`button-${banco}`} type='submit'>Continuar</Button>
                        <p>
                            Ya estás registrado? <a onClick={this.handleLogin} style={{ cursor: 'pointer' }} >Logueate</a>
                        </p>
                    </Form>
                    {
                        showMessage && message !== '' ? (
                            <Label color='red' key='red'>
                                {message}
                            </Label>
                        ) : (
                                <span />
                            )
                    }

                </Grid.Column>
            </Grid>
        )
    }
}

const mapStateToProps = (state) => ({
    message: state.step1Reducer.message,
    destinations: state.step1Reducer.destinos,
    redirect: state.loginReducer.stepRedirect,
    isLoggerdIn: state.loginReducer.isLoggerdIn
})

const mapDispatchToProps = (dispatch) => ({
    handleDestination: () => dispatch(getDestination()),
    handleSendMail: (payload) => dispatch(sendAction(payload)),
    // handleSavePass: (payload) => dispatch(savePassAction(payload)),
    handleEmail: (email) => dispatch(addMailAction(email)),
    handleCompany: (company) => dispatch(saveTypeCompany(company)),
    handleCuit: (cuit) => dispatch(addCuitAction(cuit))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Step1))




// WEBPACK FOOTER //
// ./src/conteiners/Step1/index.js